import { NikeImage, PinIcon, SearchIcon, UserImage, UserImage2, UserImage3 } from 'assets'
import { CustomModal } from 'components'
import React, { useState } from 'react'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import {
   resetDddBookmarkObj,
   setChannelListArray,
   updateBookmarkChannelAction
} from 'store/action/settingsReducer'
import { convertObjectToFormData } from 'utils/convertFormData'
import { createImageUrl } from 'utils/createImageUrl'

function OpenSearchModal({ show, onClose, onChangeChannel }) {
   const settingData = useSelector((state) => state.settings)
   const { channelList, addBookmarkStatus, addBookmarkObj, selectedUserTypes } = settingData

   const [newArray, setNewArray] = useState([])
   const [finalArray, setFinalArray] = useState([])
   const dispatch = useDispatch()
   const [isUpdate, setIsUpdate] = useState(true)
   const [bookmarkChannelLength, setBookmarkChannelLength] = useState(0)
   const [searchQuery, setSearchQuery] = useState('')

   useEffect(() => {
      if (channelList && channelList?.length > 0) {
         setNewArray(channelList)
      }
      return () => {}
   }, [channelList])

   useEffect(() => {
      if (addBookmarkStatus && addBookmarkObj?.channel_id) {
         let updatedItems = newArray.map((item) => {
            if (item?.channel_id === addBookmarkObj?.channel_id) {
               return { ...addBookmarkObj } // Set is_bookmark to true
            }
            return item // Return the item unchanged
         })
         dispatch(resetDddBookmarkObj())
         dispatch(setChannelListArray(updatedItems))
         setIsUpdate(true)
         setNewArray(updatedItems)
      }
      return () => {}
   }, [addBookmarkStatus])

   useEffect(() => {
      if (newArray && newArray?.length > 0 && isUpdate) {
         let bookmarkedItems = newArray.filter((item) => item.is_bookmark === true)
         setBookmarkChannelLength(bookmarkedItems?.length || 0)
         let nonBookmarkedItems = newArray.filter((item) => item.is_bookmark === false)
         let sortedItems = [...bookmarkedItems, ...nonBookmarkedItems]
         setIsUpdate(false)
         setFinalArray(sortedItems)
      }
      return () => {}
   }, [newArray, isUpdate])

   const handleSearchChange = (e) => {
      setSearchQuery(e.target.value)
   }

   const filteredArray = finalArray.filter((item) =>
      item.channel_name.toLowerCase().includes(searchQuery.toLowerCase())
   )

   return (
      <div>
         <CustomModal show={show} title={'Search Channel'} closeModal={onClose} centered scrollable>
            <div>
               <div className="serach-action-wrap">
                  <div className="serach-list-section">
                     <div className="serach-input-box-wrap">
                        <SearchIcon />
                        <input
                           className="form-control serach-input-box"
                           placeholder="Search..."
                           value={searchQuery}
                           onChange={handleSearchChange}
                        />
                     </div>
                     {bookmarkChannelLength >= 4 && (
                        <div className="reach-limit">
                           You've reached the limit. You can pin only 4 channel at a time
                        </div>
                     )}
                     <div>
                        {filteredArray && filteredArray?.length > 0 ? (
                           filteredArray?.map((item, i) => {
                              return (
                                 <div key={i}>
                                    <BookMarkChannel
                                       item={item}
                                       bookmarkChannelLength={bookmarkChannelLength}
                                       onClose={onClose}
                                       onChangeChannel={onChangeChannel}
                                    />
                                 </div>
                              )
                           })
                        ) : (
                           <div className="result-not-found">
                              <span>Channel not found</span>
                           </div>
                        )}
                     </div>
                  </div>
               </div>
            </div>
         </CustomModal>
      </div>
   )
}

export default OpenSearchModal

const BookMarkChannel = (props) => {
   const { item, bookmarkChannelLength, onClose,onChangeChannel } = props
   const settingData = useSelector((state) => state.settings)
   const { selectedUserTypes } = settingData
   const dispatch = useDispatch()
   const navigate = useNavigate()

   const onSelectChannel = (channel_id) => {
      onChangeChannel(channel_id)
      // navigate(`/dashboard?userType=${selectedUserTypes}&channel_id=${channel_id}`)
      onClose()
   }

   return (
      <div className="list-user-section">
         <div
            className="user-details"
            onClick={() => {
               onSelectChannel(item.channel_id)
            }}>
            <img src={item?.logo ? createImageUrl(item?.logo) : UserImage} alt="user" />
            <div className="user-name-section">
               <p>{item?.channel_name}</p>
               <span>Risk Level {item?.global_risk_score}</span>
            </div>
         </div>

         {bookmarkChannelLength >= 4 ? (
            item?.is_bookmark && (
               <div
                  className={`pin-section ${item?.is_bookmark ? '' : 'un-pin'}`}
                  onClick={() => {
                     const data = convertObjectToFormData({
                        is_bookmark: !item?.is_bookmark,
                        channel_id: item?.channel_id
                     })
                     dispatch(updateBookmarkChannelAction(data))
                  }}>
                  <PinIcon />
               </div>
            )
         ) : (
            <div
               className={`pin-section ${item?.is_bookmark ? '' : 'un-pin'}`}
               onClick={() => {
                  const data = convertObjectToFormData({
                     is_bookmark: !item?.is_bookmark,
                     channel_id: item?.channel_id
                  })
                  dispatch(updateBookmarkChannelAction(data))
               }}>
               <PinIcon />
            </div>
         )}
      </div>
   )
}
